export default __webpack_public_path__ + "static/manufacturing1-61c29550aeddc635c35bf285048bdcf8.png";